import { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { CustomButton } from "./CustomButton";
import Swal from "sweetalert2";
import axios from "axios";

const CamaraComponent = ({
  selectedMaterial,
  selectedMaterialDescr,
  onPhotosChange,
  mongoData,
  onClose,
  opt,
  orderId,
}) => {
  const { idOrder } = useParams();
  const videoRef = useRef(null);
  const [photos, setPhotos] = useState([]);

  const startCamera = async () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      } catch (error) {
        console.error("Error al acceder a la cámara:", error);
      }
    }
  };

  useEffect(() => {
    startCamera();
  }, []);

  const generateRandomIndex = () => Math.floor(Math.random() * 1000000);

  const takePhoto = () => {
    if (!selectedMaterial) {
      return;
    }
    const canvas = document.createElement("canvas");
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
    const photoData = canvas.toDataURL("image/png");
    const randomIndex = generateRandomIndex();

    const newPhoto = {
      data: photoData,
      index: randomIndex,
      description: "SIN DESCRIPCIÓN",
    };

    const updatedPhotos = [...photos, newPhoto];
    setPhotos(updatedPhotos);
    onPhotosChange?.(updatedPhotos.map((p) => p.data));
  };

  //Actualiza la descripción de una foto
  const updatePhotoDescription = (index, newDescription) => {
    const updatedPhotos = photos.map((photo, i) => {
      if (i === index) {
        return {
          ...photo,
          description: newDescription.trim() || "",
        };
      }
      return photo;
    });
    setPhotos(updatedPhotos);
  };

  const guardarEvidencia = async () => {
    if (!photos || photos.length === 0 || !selectedMaterial) {
      Swal.fire({
        icon: "info",
        title: "Toma al menos una foto antes de continuar",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
      return;
    }
    const formData = new FormData();
    if (opt === "2" || opt === "3") {
      formData.append("idOrder", orderId);
    } else {
      formData.append("idOrder", idOrder);
    }
    /*const materialData = mongoData?.find(
      (m) => m.material === selectedMaterial
    );*/
    /*console.log("MATERIAL DATA", materialData);
    const descripcionMaterial = materialData?.["EVIDENCIA"] || ""; // Este array de 'materiales' solo informa al backend qué materiales procesar.
    console.log("DESCRIPCION MATERIAL", descripcionMaterial);*/
    formData.append(
      "materiales",
      JSON.stringify([
        {
          material: selectedMaterial,
          descripcionMaterial: selectedMaterialDescr,
        },
      ])
    );
    const descripcionesParaBackend = {
      [selectedMaterial]: photos.map((photoObj) => ({
        fileName: `${selectedMaterial}_${photoObj.index}.png`,
        descripcion: photoObj.description,
      })),
    };
    formData.append(
      "descripcionesFotos",
      JSON.stringify(descripcionesParaBackend)
    );
    /*if (opt) {
      formData.append("tipoReporte", opt);
    }*/
    photos.forEach((photoObj) => {
      const byteString = atob(photoObj.data.split(",")[1]);
      const mimeString = photoObj.data
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i);
      const blob = new Blob([ab], { type: mimeString });
      formData.append(
        selectedMaterial,
        blob,
        `${selectedMaterial}_${photoObj.index}.png`
      );
    });
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/guardarEvidencias`,
        formData
      );
      console.log("Evidencias guardadas:", data);
      setPhotos([]);
      onPhotosChange?.([]);
      onClose?.();
    } catch (error) {
      console.error("Error al guardar evidencia:", error);
    }
  };

  const removePhoto = (index) => {
    const updatedPhotos = photos.filter((_, i) => i !== index);
    setPhotos(updatedPhotos);
    onPhotosChange?.(updatedPhotos.map((p) => p.data));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <div style={{ textAlign: "center" }}></div>

      <video ref={videoRef} width="100%" style={{ borderRadius: "8px" }} />

      <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
        <CustomButton onClick={takePhoto}>Tomar Foto</CustomButton>
        <CustomButton
          sx={{ backgroundColor: "#28a745" }}
          onClick={guardarEvidencia}
          disabled={!photos || photos.length === 0}>
          Guardar evidencia ({photos.length})
        </CustomButton>
      </div>

      {photos.length > 0 && (
        <div
          style={{
            display: "flex",
            overflowX: "auto",
            gap: "10px",
            padding: "0.5rem 0",
          }}>
          {photos.map((photoObj, index) => (
            <div
              key={photoObj.index}
              style={{ position: "relative", flex: "0 0 100px" }}>
              <img
                src={photoObj.data}
                alt={`foto-${photoObj.index}`}
                style={{
                  width: "110px",
                  height: "80px",
                  objectFit: "cover",
                  borderRadius: "5px",
                }}
              />

              {/* INPUT DE DESCRIPCIÓN POR FOTO */}
              <textarea
                value={photoObj.description}
                onChange={(e) => updatePhotoDescription(index, e.target.value)}
                placeholder="Descripción de la foto"
                style={{
                  width: "100%",
                  fontSize: "12px",
                  padding: "2px",
                  marginTop: "5px",
                  boxSizing: "border-box",
                }}
              />

              {/* Botón de eliminar foto */}
              <svg
                onClick={() => removePhoto(index)}
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  backgroundColor: "white",
                  borderRadius: "50%",
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                }}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ff3b30"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M10 10l4 4m0 -4l-4 4" />
                <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
              </svg>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CamaraComponent;
